// extracted by mini-css-extract-plugin
module.exports = {"theme":"#5473e8"};